<template>
  <div class="network-create">
    <Input
      label="servers.networkName"
      id="name"
      v-model="form.name"
      :state="validateState('name')"
    />

    <b-form-group
      :label="$t('forms.vm.dcNode')"
      :state="validateState('dcNode')"
    >
      <multiselect
        v-model="form.dcNode"
        :options="dcNodeList"
        track-by="id"
        label="name"
        :loading="loading"
        :allowEmpty="false"
        :show-labels="false"
        :searchable="true"
        :placeholder="$t('forms.vm.dcNode')"
        :show-no-results="false"
      />
    </b-form-group>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'NetworkCreate',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      form: {
        name: '',
        dcNode: '',
      },
      dcNodeList: [],
      loading: false,
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      dcNode: {
        required,
      },
    },
  },
  created() {
    this.getDatacenterNodes()
  },
  methods: {
    getDatacenterNodes() {
      this.getDatacenterNodeList()
        .then((res) => {
          this.setDatacenterNodeList(res)
        })
        .catch(() => {
          this.dcNodeList = []
        })
    },
    getDatacenterNodeList() {
      this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/datacenter-nodes?orderBy=position|ASC`)
          .then(({ data }) => {
            resolve(data)
            this.loading = false
          })
          .catch((err) => {
            reject(err)
            this.loading = false
          })
      })
    },
    setDatacenterNodeList(res) {
      if (res && res.data && res.data.length > 0) {
        this.dcNodeList = res.data.filter(
          (f) => f.name.toLowerCase().includes('kapatılacak') == false
        )
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
        datacenter_node_id: this.form.dcNode.id,
      }

      ApiService.post(`iaas/networks`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
